import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/components/ui/AppIcon.tsx");
